export default "/_next/static/images/lindsey-canfield-5277f0a3b2df921c84bf190036066580.png";